class Choice {
    constructor({ id, stepId, target, title = null }) {
        this.id = id;
        this.stepId = stepId;
        this.target = target;
        this.title = title;
    }
}

export default Choice;
